<template lang="html">
  <div id="neighbourhood-nav" :class="{ collapsed: menuClosed }">
    <div class="nav-list h-100 d-flex flex-column align-items-start justify-content-center">
      <router-link
        to="/neighbourhood/heart"
        class="link d-block"
      >
        <div class="link-text">
          Living in the Heart<br>of the City
        </div>
        <div class="active-link" :class="{ active: $route.name === 'Heart'}"></div>
      </router-link>
      <router-link
        to="/neighbourhood/"
        @click.native="setNeighbourhoodNavActive(false)"
        class="link d-block"
      >
        <div class="link-text">
          Your Neighbourhood
        </div>
        <div class="active-link" :class="{ active: $route.name === 'Neighbourhood'}"></div>
      </router-link>
      <router-link
        to="/neighbourhood/video"
        class="link d-block"
      >
        <div class="link-text">
          Experience Place and Home, Redefined
        </div>
        <div class="active-link" :class="{ active: $route.name === 'Video'}"></div>
      </router-link>
      <div class="nav-toggle position-absolute d-flex align-items-center justify-content-center"
        @click="setNeighbourhoodNavActive(!menuClosed)"
        :class="{ visible: $route.name === 'Neighbourhood' }"
      >
        <i class="fas fa-chevron-right" v-if="menuClosed"></i>
        <i class="fas fa-chevron-left" v-else></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'neighbourhood-nav',
  data() {
    return {
      menuClosed: false,
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      deviceLg: 'ui/deviceLg'
    })
  },
  methods: {
    setNeighbourhoodNavActive(enabled) {
      this.menuClosed = enabled;
    }
  },
  mounted() {
    setTimeout(() => {
      this.menuClosed = true;
    }, 500);
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      if (from.name === 'Video' && to.name === 'Neighbourhood') {
        this.menuClosed = false;
        setTimeout(() => {
          this.menuClosed = true;
        }, 1500);
      } else if (to.name === 'Neighbourhood') {
        setTimeout(() => {
          this.menuClosed = true;
        }, 500);
      }
    }
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>

#neighbourhood-nav {
  position: fixed;
  background-color: var(--branding);
  height: calc(100vh - #{$app-bar-height});
  width: $neighbourhoodNavWidth;
  top: 0px;
  left: 0px;
  transition: all 0.5s ease-out;
  // overflow: hidden;

  &.collapsed {
    left: calc(-#{$neighbourhoodNavWidth} + #{$neighbourhoodNavToggleWidth});
  }

  .nav-toggle {
    background-color: #BA5D5A;
    color: white;
    right: 0px;
    bottom: 0px;
    height: 40px;
    width: 40px;
    cursor: pointer;

    visibility: hidden;

    &.visible {
      visibility: visible;
    }
  }

  .link {
    text-align: left;
    color: white;
    margin: 2rem 0rem 2rem 0rem;
    font-family: Didot-Regular;
    font-size: 33px;
    line-height: 47px;
    overflow: hidden;
    position: relative;
    width: 100%;

    .link-text {
      margin-left: 3rem;
      margin-right: 6rem;
    }

    .active-link {
      background-color: white;
      height: 1px;
      width: 100px;
      position: absolute;
      top: 50%;
      right: -50%;
      transition: all 0.3s ease-out;

      &.active {
        right: 0%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodNav.vue